import $ from 'jquery';
import {
    LOADING_CLASS
} from '../constants/classes';
/*
/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    PAGE_CONTENT: '.site-bd',
    FORM: '.js-chooseAddressView-form',
    PROCEED_CTA: '.js-chooseAddressView-proceed',
    ADDRESS_OPTION_CHECKBOX: '.js-chooseAddressView-option',
    ADDRESS_OPTION_INFO: '.js-chooseAddressView-optionInfo',
    ADDRESS_OPTION_INFO_ADDRESS: '.js-chooseAddressView-optionInfo-address1',
    ADDRESS_OPTION_INFO_ADDRESS_2: '.js-chooseAddressView-optionInfo-address2',
    ADDRESS_OPTION_INFO_CITY: '.js-chooseAddressView-optionInfo-city',
    ADDRESS_OPTION_INFO_STATE: '.js-chooseAddressView-optionInfo-state',
    ADDRESS_OPTION_INFO_POSTAL_CODE: '.js-chooseAddressView-optionInfo-postalCode',

    /* The above are selectors that contain values which will populate the fields that are represented by these selectors below */
    ADDRESS_FIELD_ADDRESS_1: '.js-chooseAddressView-field-address1',
    ADDRESS_FIELD_ADDRESS_2: '.js-chooseAddressView-field-address2',
    ADDRESS_FIELD_CITY: '.js-chooseAddressView-field-city',
    ADDRESS_FIELD_STATE: '.js-chooseAddressView-field-state',
    ADDRESS_FIELD_POSTAL_CODE: '.js-chooseAddressView-field-postalCode',
};

/**
 * Queries address selections presented to the user
 * and then populates their form with the values within
 * the option they choose, then allowing them to submit
 * the form with those values.
 *
 * @class ChooseAddressView
 * @constructor
 */
export default class ChooseAddressView {
    constructor($element) {
        this.$element = $element;
        return this.setupHandlers()
            .createChildren()
            .layout()
            .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.onPickedAddressHandler = this.onPickedAddress.bind(this);
        this.onProceedClickHandler = this.onProceedClick.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$pageContent = $(SELECTORS.PAGE_CONTENT);
        this.$form = this.$pageContent.find(SELECTORS.FORM);
        this.$proceedCta = this.$pageContent.find(SELECTORS.PROCEED_CTA);
        this.$addressOptionCheckbox = this.$element.find(SELECTORS.ADDRESS_OPTION_CHECKBOX);
        this.$addressOptionInfo = this.$element.find(SELECTORS.ADDRESS_OPTION_INFO);
        this.$addressFieldName = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_NAME);
        this.$addressFieldAddress1 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_1);
        this.$addressFieldAddress2 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_2);
        this.$addressFieldCity = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_CITY);
        this.$addressFieldState = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_STATE);
        this.$addressFieldPostalCode = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_POSTAL_CODE);

        return this;
    }

    /**
     * Does any scripts on load
     *
     * @method layout()
     * @public
     * @chainable
     */
    layout() {
        this.$element.focus();
        return this;
    }

    /**
     * Grabs the values from the presented
     * address options
     *
     * @method onPickedAddress
     * @public
     * @chainable
     */
    onPickedAddress(e) {
        const $target = e.currentTarget.nextElementSibling;
        /* Retrieves values from suggested address */
        const $address1 = $($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS)[0] !== undefined ? $($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS)[0].innerText : false;
        const $address2 = $($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS_2)[0] !== undefined ? $($target).find(SELECTORS.ADDRESS_OPTION_INFO_ADDRESS_2)[0].innerText : false;
        const $city = $($target).find(SELECTORS.ADDRESS_OPTION_INFO_CITY)[0] !== undefined ? $($target).find(SELECTORS.ADDRESS_OPTION_INFO_CITY)[0].innerText : false;
        const $state = $($target).find(SELECTORS.ADDRESS_OPTION_INFO_STATE)[0] !== undefined ? $($target).find(SELECTORS.ADDRESS_OPTION_INFO_STATE)[0].innerText : false;
        const $postalCode = $($target).find(SELECTORS.ADDRESS_OPTION_INFO_POSTAL_CODE)[0] !== undefined ? $($target).find(SELECTORS.ADDRESS_OPTION_INFO_POSTAL_CODE)[0].innerText : false;


        this._updateAddressFields($address1, $address2, $city, $state, $postalCode);
        this.$proceedCta.show();
        return this;
    }

    /**
     * Updates address form fields if those
     * fields exist in the option and 
     * if they exist in the form itself
     *
     * @method updateAddressFields
     * @private
     * @chainable
     */
    _updateAddressFields($address1, $address2, $city, $state, $postalCode) {
        this.$addressFieldAddress1 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_1)[0];
        this.$addressFieldAddress2 = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_ADDRESS_2)[0];
        this.$addressFieldCity = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_CITY)[0];
        this.$addressFieldState = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_STATE)[0];
        this.$addressFieldPostalCode = this.$pageContent.find(SELECTORS.ADDRESS_FIELD_POSTAL_CODE)[0];
        let fieldsToUpdate = [this.$addressFieldAddress1, this.$addressFieldAddress2, this.$addressFieldCity, this.$addressFieldState, this.$addressFieldPostalCode];
        for (let i = 0; i < arguments.length; i++) {
            if (fieldsToUpdate[i] !== undefined) {

                fieldsToUpdate[i].value = arguments[i];
                continue;
            }
            console.info('parameter at position ', [i], ' in updateAddressMethod()  couldnt find a corresponding address field to update');
        }
        return this;
    }

    /**
     * Submits the form 
     * that now has updated
     * Address field info
     *
     * @method onProceedClick
     * @public
     * @chainable
     */
    onProceedClick(e) {
        this.$element.find(SELECTORS.PROCEED_CTA).addClass(LOADING_CLASS);
        this.$form.submit();
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        this.$addressOptionCheckbox.on('click input', this.onPickedAddressHandler);
        this.$proceedCta.on('click', this.onProceedClickHandler);
        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        this.$addressOptionInfo.off('click input', this.onPickedAddressHandler);
        this.$proceedCta.off('click', this.onProceedClickHandler);
        return this;
    }
}